module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/changepassword/changepassword.component.scss
// module id = ./src/app/changepassword/changepassword.component.scss
// module chunks = main